import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const schedulerConfigurationFieldsSchema = z.object({
  startDate: coercedDate,
  frequency: z.string(),
  numberOfDevices: z.number(),
});

export const schedulerConfigurationSchema =
  schedulerConfigurationFieldsSchema.extend({
    accountId: z.number(),
    cutOffDaysRelativeToStartDate: z.number(),
    terminateFutureCycle: z.boolean(),
    terminationDate: coercedDate.nullable(),
  });

export type SchedulerConfigurationFields = z.infer<
  typeof schedulerConfigurationFieldsSchema
>;

export type SchedulerConfiguration = z.infer<
  typeof schedulerConfigurationSchema
>;
